export default __webpack_public_path__ + "static/media/manage-users-small.f72abe1e.svg";